<script setup>
import { ref, computed, defineExpose } from 'vue';
import modal from './modal.vue';
import { useStore } from "vuex";
import { useI18n } from "vue-i18n/index";
import ApiService from '@/core/services/ApiService';
const store = useStore();
const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));
const { t } = useI18n();
const user = computed(() => store.getters.currentUser);
const props = defineProps({
  module: {
    type: Object,
    required: true
  }
});
const modalRef = ref(null);
const shareOnLinkedin = (userId) => {
  const url = `${process.env.VUE_APP_SHARE_URL}achievement/module/${props.module.id}/user/${userId}`;
  const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
  window.open(linkedinUrl, "_blank");
};
const markAsRead = async () => {
  try {
    if (props.module.achievement && !props.module.achievement.is_read) {
      await ApiService.put(`/achievements/${props.module.achievement.id}/mark-as-read`);
    }
  } catch (error) {
    console.error("Error marking as read:", error);
  }
};
const openModal = () => {
  modalRef.value.open();
};
defineExpose({
  openModal
});
</script>

<template>
  <modal ref="modalRef" target="module_achievement_modal">
    <template #header>
      <div class="d-flex justify-content-center align-items-center flex-column w-100">
        <div class="w-100 d-flex justify-content-end" style="position: absolute; top: 10px; right: 10px;">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal" @click="markAsRead">X</button>
        </div>
        <div class="mb-12 d-flex justify-content-center">
          <img :src="props.module.image_url" class="avatar-img img-fluid floating" style="width: 50%;" alt="image" />
        </div>
        <h3 class="text-center" style="color:#9203DD;font-size: 24px;font-weight: bold">{{
          t(`${currentLanguage}.achivement.module.title`) }}
          <small class="bi bi-check-circle-fill text-success fs-2"></small>
        </h3>
      </div>
    </template>
    <template #body>
      <p style="font-weight: bold; text-align: center">
        {{ t(`${currentLanguage}.achivement.module.message_1`, { user: user.nick || 'No nick' }) }}
      </p>
      <p class="text-center">
        {{ t(`${currentLanguage}.achivement.module.message_2`, { module: props.module.title }) }}
      </p>

      <div class="d-flex justify-content-between">
        <div style="width: 50%">
          <img src="/media/hc/lux_1.png" alt="Achievement" style="width: 110% " />
        </div>
        <div class="d-flex flex-column align-items-center justify-content-center mt-6" style="width: 50%">
          <button @click="shareOnLinkedin(user.id)" type="button" class="btn btn-custom-achievement mt-12">
            <span class="bi bi-linkedin" />
            {{ t(`${currentLanguage}.common.share_on_linkedin`) }}
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>
<style>
.btn-custom-achievement {
  background-color: #6E05D0;
  color: white;
  width: 225px;
  transition: all 0.2s ease-in-out;
  font-size: 13px;
}

.btn-custom-achievement:hover {
  background-color: white;
  color: #6E05D0;
  border: 1px solid #6E05D0;
}
</style>